import React from 'react'

function DownvoteFilled({ size, color }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_23161_68458)">
        <path d="M15 3.5H6C5.17 3.5 4.46 4 4.16 4.72L1.14 11.77C1.05 12 1 12.24 1 12.5V14.5C1 15.6 1.9 16.5 3 16.5H9.31L8.36 21.07L8.33 21.39C8.33 21.8 8.5 22.18 8.77 22.45L9.83 23.5L16.42 16.91C16.78 16.55 17 16.05 17 15.5V5.5C17 4.4 16.1 3.5 15 3.5ZM19 3.5V15.5H23V3.5H19Z" fill={color} />
      </g>
      <defs>
        <clipPath id="clip0_23161_68458">
          <rect width={size} height={size} fill="white" transform="translate(0 0.5)" />
        </clipPath>
      </defs>
    </svg>

  )
}

export default DownvoteFilled